import { MessageCircle, Phone } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { WHATSAPP_HREF, VIBER_HREF } from "../../lib/contact";

export const ContactMenu = ({ triggerClassName, side = "bottom", testid }) => (
  <DropdownMenu modal={false}>
    <DropdownMenuTrigger data-testid={testid} className={triggerClassName}>
      WhatsApp / Viber
    </DropdownMenuTrigger>
    <DropdownMenuContent
      side={side}
      align="end"
      className="rounded-none border-2 border-navy bg-ivory p-0 text-navy min-w-[14rem]"
    >
      <DropdownMenuItem asChild className="rounded-none px-5 py-4 text-lg font-semibold cursor-pointer focus:bg-mist">
        <a href={WHATSAPP_HREF} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-whatsapp`}>
          <MessageCircle className="mr-3 h-5 w-5 text-sage" /> WhatsApp üzenet
        </a>
      </DropdownMenuItem>
      <DropdownMenuItem asChild className="rounded-none px-5 py-4 text-lg font-semibold cursor-pointer focus:bg-mist border-t-2 border-navy/15">
        <a href={VIBER_HREF} data-testid={`${testid}-viber`}>
          <Phone className="mr-3 h-5 w-5 text-burgundy" /> Viber üzenet
        </a>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
